<template>
  <div class="feedback">
    <div class="mask" v-if="loading">
      <van-loading size="40px" vertical class="loading-custom">上传中...</van-loading>
    </div>
    <div class="spacing">{{$t('lang.feedback.cateTitle')}}</div>
    <div class="category">
      <ul>
        <li
          v-for="(item, index) in categoryList"
          :key="index"
          v-on:click="selectReportType(index, item.id)"
        >
          <img src="../assets/icon_notcheck@2x.png" alt v-show="activeIndex != index" />
          <img src="../assets/loading_icon_check@2x.png" alt v-show="activeIndex == index" />
          <span>{{item.name}}</span>
        </li>
      </ul>
    </div>
    <div class="spacing">{{$t('lang.feedback.contentTitle')}}</div>
    <div class="feedback-content">
      <form action="javascript:void 0">
        <textarea
        name="reportDesc"
        id="report-desc"
        cols="30"
        rows="10"
        maxlength="50"
        class="report-desc"
        :placeholder="$t('lang.feedback.placeholder1')"
        v-model="feedbackData.content"
        @mouseout="reportDescOut"
        @keyup.13="reportDescOut"
      ></textarea>
	   </form>
      
      <!-- @input="reportDescInput" -->
      <div class="upload-wrapper">
        <div class="img-list">
          <div v-for="(item, index) in imgUrls" :key="index" class="img-wrapper">
            <!-- <img :src="item" alt class="img-preview"> -->
            <div style="background:#fff;opacity:0;position: absolute;width:14px;height:14px;top:0;right: 10px;" @click="deleteImg(item)"></div>
            <div class="img-preview" :style="'background-image: url('+item+');'"></div>
            <img
              src="../assets/icon_delete@2x.png"
              alt
              class="delete"
              v-show="imgUrls.length"
              @click="deleteImg(item)"
            />
          </div>
        </div>
        <div @click="choosePhoto">
          <van-uploader
            :after-read="onRead"
            :max-size="maxSize"
            :oversize="oversize"
            v-show="imgUrls.length!=3"
            accept="image/gif, image/jpeg, image/png, image/jpg"
          >
            <img src="../assets/icon_add@2x.png" alt class="icon-add" />
          </van-uploader>
        </div>
      </div>
    </div>
    <div class="spacing">{{$t('lang.feedback.contactTitle')}}</div>
    <div class="contact-wrapper">
      <form action="javascript:void 0">
        <input type="text" :placeholder="$t('lang.feedback.placeholder2')" v-model="feedbackData.contact" @mouseout="reportDescOut" @keypress="keyPress"/>
      </form>
    </div>
    <div class="bottom-btn">
      <button @click="submitReport" :disabled="disabled">{{$t('lang.feedback.submitBtn')}}</button>
      <!-- :disabled="disabledBtn"
      :class="[!disabledBtn?'active-btn':'']"-->
    </div>
  </div>
</template>
<script>
import { Uploader, Toast, Loading } from "vant";
import {getFeedbackList, upload, submitFeedback} from '@/api/api';
export default {
  components: {
    [Uploader.name]: Uploader,
    [Loading.name]: Loading
  },
  data() {
    return {
      categoryList: [],
      activeIndex: 0,
      feedbackData: {
        categoryId: 1,
        content: "",
        imageUuids: [],
        contact: ""
      },
      maxSize: 5242880,
      disabled: false,
      disabledTextarea: false,
      maxLength: 500,
      minLength: 0,
      imgUrls: [],
      loading: false
    };
  },
  beforeMount: function() {
    this.init();
  },
  methods: {
    // 安卓
    choosePhoto() {
      Toast.loading({
        mask: true,
        className: "van-loading-custom"
      });
      var that = this;
      if (that.imgUrls.length >= 3) {
        Toast(this.$t('lang.feedback.atten1'));
      } else {
        this.setupWebViewJavascriptBridge(function(bridge) {
          bridge.callHandler("choosePhoto", {}, function(response) {
            Toast.clear();
            that.imgUrls.push(response.fileUrl);
            that.feedbackData.imageUuids.push(response.uuid);
          });
        });
      }
    },
    init() {
      document.onkeydown=function(event){
        var e = event || window.event || arguments.callee.caller.arguments[0];
        if(e && e.keyCode==13){
          window.scrollTo(0, 0);
          document.body.scrollTop = 0
        }
      }
      getFeedbackList().then(res => {
        this.categoryList = res.data;
      });
    },
    feedbackFocus(event) {
      this.disabledBtn = false;
    },
    reportDescOut(){
      this.$nextTick(function() {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0
      });
    },
    keyPress(e){
      console.log(e)
    },
    oversize() {
      Toast(this.$t('lang.feedback.atten2'));
    },
    onRead(file) {
      var that = this;
      that.loading = true;
      if (that.imgUrls.length >= 3) {
        Toast(this.$t('lang.feedback.atten1'));
      } else {
        const formData = new FormData();
        formData.append("file", file.file);
        formData.append("appId", 254);
        formData.append("description", "专注意见反馈图片");
        upload(formData).then(res => {
          if (res) {
            that.loading = false;
            this.imgUrls.push(res.data.url);
            this.feedbackData.imageUuids.push(res.data.uuid);
          }
        });
      }
    },
    deleteImg(item) {
      var that = this;
      const index = that.imgUrls.indexOf(item);
      if (index > -1) {
        that.imgUrls.splice(index, 1);
        that.feedbackData.imageUuids.splice(index, 1);
      }
      if (this.imgUrls.length < 3) {
        this.isShowUpload = true;
      }
    },
    selectReportType(index, id) {
      this.activeIndex = index;
      this.feedbackData.categoryId = id;
    },
    submitReport() {
      var that = this;
      this.disabled = true;
      if (that.feedbackData.content == "" && !that.imgUrls.length) {
        Toast(this.$t('lang.feedback.atten3'));
        this.disabled = false;
      } else {
        submitFeedback(that.feedbackData).then(res => {
          if(res.error){
            Toast(res.error.message);
          }else{
            Toast.success({
              mask: true,
              message: that.$t('lang.feedback.submitSuccess')
            });
            this.feedbackData.content = "";
            this.imgUrls = [];
            this.feedbackData.contact = "";
            this.feedbackData.imageUuids = [];
          }
          this.disabled = false;
        });
      }
      
    },
    setupWebViewJavascriptBridge: function(callback) {
      var that = this;
      // if (window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge); }
      // if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
      if (window.WebViewJavascriptBridge) {
        return callback(WebViewJavascriptBridge);
      } else if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
      } else {
        document.addEventListener(
          "WebViewJavascriptBridgeReady",
          function() {
            callback(WebViewJavascriptBridge);
          },
          false
        );
      }
      window.WVJBCallbacks = [callback];
      var WVJBIframe = document.createElement("iframe");
      WVJBIframe.style.display = "none";
      var WVJBIframeSrc = that.isiOS
        ? "https://__bridge_loaded__"
        : "wvjbscheme://__BRIDGE_LOADED__";

      WVJBIframe.src = WVJBIframeSrc;
      document.documentElement.appendChild(WVJBIframe);
      setTimeout(function() {
        document.documentElement.removeChild(WVJBIframe);
      }, 0);
    }
  }
};
</script>
<style lang="less">
.feedback {
//   width: 100%;
//   height: 100%;
  background: #f9f9f9;
  // position: fixed;
  .mask{
    width: 100%;
    height: 100%;
    background-color: rgba(50,50,51,.88);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    .loading-custom{
      position: relative;
      top: 40%;
    }
  }
  .spacing {
    height: 30px;
    font-size: 13px;
    color: rgba(102, 102, 102, 1);
    line-height: 30px;
    padding-left: 19px;
  }
  .category {
    ul {
      padding-left: 20px;
      background: #fff;
      li {
        display: inline-block;
        font-size: 15px;
        line-height: 50px;
        margin-right: 30px;
        img {
          width: 15px;
          height: 15px;
          margin-right: 5px;
          vertical-align: middle;
          position: relative;
          bottom: 2px;
        }
      }
    }
  }
  .feedback-content {
    background: #fff;
    padding-left: 20px;
    height: 221px;
    position: relative;
    .report-desc {
      width: 335px;
      height: 110px;
      border-radius: 6px;
      border: none;
      padding: 15px 0;
      margin-bottom: 5px;
      font-size: 15px;
      line-height: 21px;
      // 去掉右下角缩放按钮
      box-sizing: content-box !important;
      resize: none;
    }
    .upload-wrapper {
      position: absolute;
      bottom: 9px;
      display: flex;
      .img-list {
        display: flex;
        .img-wrapper {
          position: relative;
          .img-preview {
            width: 56px;
            height: 56px;
            background-size: cover;
            border-radius: 2px;
            border: 1px solid rgba(204, 204, 204, 1);
            margin-right: 10px;
          }
          .delete {
            width: 13px;
            height: 13px;
            position: absolute;
            right: 10px;
            top: 0;
          }
        }
      }
      .icon-add {
        width: 56px;
        height: 56px;
      }
    }
  }
  .contact-wrapper {
    width: 375px;
    height: 50px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    input {
      // padding: 15px 0 14px 20px;
      width: 355px;
      border: none;
      height: 50px;
      padding-left: 20px;
      font-size: 15px;
      line-height: 21px;
    }
  }
  .bottom-btn {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    button {
      width: 311px;
      height: 52px;
      background:linear-gradient(90deg,rgba(115,204,146,1) 0%,rgba(1,164,161,1) 100%);
      box-shadow: 0px 8px 10px 0px rgba(40,184,143,0.3);
      border-radius: 26px;
      border: none;
      margin-bottom: 40px;
      font-size: 16px;
      font-family: PingFangSC-Medium,PingFang SC;
      font-weight: 500;
      color: rgba(255,255,255,1);
      line-height: 52px;
    }
    .active-btn {
      background: rgba(54, 203, 160, 1);
    }
  }
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #ccc;
}
input:-moz-placeholder,
textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc;
}
input::-moz-placeholder,
textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc;
}
input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #ccc;
}
// Toast loading
.van-loading-custom {
  background-color: rgba(50, 50, 51, 0);
  .van-loading {
    width: 50px;
    height: 50px;
  }
}
</style>